import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { MrpProcessInstanceLinesContainerModel} from '../../../../../../models/aggregates/mrp-prodsys';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Pagination } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class MrpProcessInstanceLinesService extends BaseApiTemplateService<MrpProcessInstanceLinesContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instance-lines"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instance-lines/backoffice-ep"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-instance-lines/backoffice-ep"
    this.httpClient = http;
  }

  
  public getLinesByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<MrpProcessInstanceLinesContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MrpProcessInstanceLinesContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
